/**
 * Configuration for advisor roles by email address
 */
export const advisorRolesByEmail: Record<string, string> = {
  // Add specific email-to-role mappings here
  'maggie.fellowes@urbanintelligence.co.nz': 'Senior Adaptation Advisor, Resilience Explorer®',
  'logan.brunner@urbanintelligence.co.nz': 'Senior Risk Analyst, Resilience Explorer®',
  'matt.edwards@urbanintelligence.co.nz': 'Risk Analyst, Resilience Explorer®',
  'callum.snell@urbanintelligence.co.nz': 'Risk Analyst, Resilience Explorer®',
  'zak.barham@urbanintelligence.co.nz': 'Risk Analyst, Resilience Explorer®',
}

/**
 * Default role for advisors when no specific mapping exists
 */
export const DEFAULT_ADVISOR_ROLE = 'Adaptation Advisor, Resilience Explorer®'

/**
 * Get the role for an advisor based on their email address
 */
export const getAdvisorRole = (email?: string): string => {
  if (!email) return DEFAULT_ADVISOR_ROLE
  return advisorRolesByEmail[email.toLowerCase()] ?? DEFAULT_ADVISOR_ROLE
}
